import { Button, Link } from "@mui/material";
import { CloudDownload } from "@mui/icons-material";
import {
  selectIsBookConversion,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";

interface Props {
  documentUrl: string | undefined;
}

export function ValuationReportButton({ documentUrl }: Props) {
  const isBookConversion = useNewBusinessSelector(selectIsBookConversion);
  const isDisabled = !documentUrl || isBookConversion;

  return (
    <Link
      rel="noreferrer"
      href={documentUrl ?? "#"}
      target={documentUrl ? "_blank" : "_self"}
      underline="none"
      sx={{
        pointerEvents: isDisabled ? "none" : "auto",
      }}
      width={"100%"}>
      <Button
        data-testid="compare-plans-button"
        size="small"
        variant="outlined"
        disabled={isDisabled}
        fullWidth>
        <CloudDownload
          sx={(theme) => ({
            marginRight: theme.spacing(0.5),
          })}
        />
        Valuation Report
      </Button>
    </Link>
  );
}
